module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-close-7eea95acd0e8f0674f7f66d5a8cb1065.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/menu-item-expanded/img/btn-close.png
 ** module id = 189
 ** module chunks = 1 9 15 16 66 78 80 118 136
 **/